import React from "react";
import { Input, Container, Row, Col } from "reactstrap";
import { useAuth0 } from "@auth0/auth0-react";

function Logout() {
  const { logout } = useAuth0();
  return (
    <Container className="logout-padding text-center">
      <Row>
        <Col md={2}>
          <Input
            value="Log out"
            className="btn btn-primary"
            onClick={() => {
              logout({
                returnTo: window.location.origin,
              });
            }}
          >
            Log out
          </Input>
        </Col>
      </Row>
    </Container>
  );
}

export default Logout;
